import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';

export default server => {
    server.get('/webhooks', ({ webhooks }, { queryParams: { name } }) => {
        if (!['zendesk', 'vanilla'].includes(name)) {
            return new Response(HTTP.NOT_FOUND);
        }

        const {
            attrs: { integration_name, uuid }
        } = webhooks.findBy({ integration_name: name });

        return `https://webhooks.affogata.com/${integration_name}/v1.0/${uuid}/webhook`;
    });
};
